import { AgGridService } from "@topline/services/agGridService";
import { ApiClient } from "@topline/services/apiService";
import { Gen } from "../../../Services/api";

interface PlannerProductSearchParams {
    page: number;
    pageSize: number;
    brand?: string;
    sku?: string;
    oracleIndex?: string;
    market?: string;
    line?: string;
    region?: string;
    businessUnit?: string;
    sortField?: string;
    sortType?: string;
    plannerId?: string;
    budgetVersionUId?: string;
    includeAssignedPlannerColumn?: boolean;
    includeApproverColumn?: boolean;
    expectProductCodes?: string[];
    includeProductCodes?: string[];
    filterType?: string;
    assignmentSource?: string;
}

export class PlannerProductSearchService {
    static componentName = "plannerProductSearchService";
    static $inject = [AgGridService.componentName, ApiClient.componentName];

    constructor(protected agGridService: AgGridService, protected apiClient: ApiClient) {}

    searchProducts(filterParams: PlannerProductSearchParams) {
        const searchOptions = {
            page: filterParams.page,
            pageSize: filterParams.pageSize,
            brand: filterParams.brand ?? null,
            sku: filterParams.sku ?? null,
            oracleIndex: filterParams.oracleIndex ?? null,
            market: filterParams.market ?? null,
            line: filterParams.line ?? null,
            region: filterParams.region ?? null,
            businessUnit: filterParams.businessUnit ?? null,
            sortField: filterParams.sortField ?? null,
            sortType: filterParams.sortType ?? null,
            plannerId: filterParams.plannerId ?? null,
            budgetVersionUId: filterParams.budgetVersionUId ?? null,
            includeAssignedPlannerColumn: filterParams.includeAssignedPlannerColumn!,
            includeApproverColumn: filterParams.includeApproverColumn!,
            expectProductCodes: filterParams.expectProductCodes ?? null,
            includeProductCodes: filterParams.includeProductCodes ?? null,
            filterType: filterParams.filterType as $TSFixMe
        };

        return this.apiClient.searchProductWithOwners(searchOptions);
    }

    createDataSource = (filterConfig: PlannerProductSearchParams) => {
        return this.agGridService.createDataSource(this.searchProducts.bind(this), filterConfig);
    };
}

angular.module("topline.services").service(PlannerProductSearchService.componentName, PlannerProductSearchService);
